import React from 'react'
import ReactStrapComponent from './ReactStrapComponent'
import Field from '../Field'


const PasswordField = (props:any) => <Field type="password" component={ReactStrapComponent} {...props} />



export default PasswordField